<script>
export default {
  props: ['item', 'isnew'],
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <div>

    <h5 class="section-header mb-3"><Icon icon="ri:footprint-line" /> Tracker details</h5>
    <p class="text-muted small">Enter a title for this tracker as well as a description if needed.</p>
    <div class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.status" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="Live :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="String" v-model="item.title" Title="Title :" required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="Textarea" Title="Description :" v-model="item.description"></w-field>
      </div>
    </div>

    <div class="clearfix mt-3"></div>

  </div>
</template>
